/**
 * Returns Google Drive working folder (Picsio) id.
 * Working folder is a parents working folder (Picsio) if user is a teammate or its own working folder.
 */
const getWorkingFolderId = (user) => (user?.isTeammate ? user.team.workingFolderId : user?.workingFolderId);

export default getWorkingFolderId;
